import React, { useEffect, useState } from "react";
import InvoiceItemRow from "./InvoiceItemRow";
import { Col, Row, Input, Button } from "reactstrap"; // Import Input and Button from reactstrap for better styling
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData, Fn_GetReport } from "store/Functions";
import { API_WEB_URLS } from "constants/constAPI";
import { useDispatch } from "react-redux";
import { json, useLocation } from "react-router-dom";

function SaleInvoice() {
  const [state, setState] = useState({
    id:0,
    formData: {
      VoucherNo: "",
      VoucherDate: new Date().toISOString().split("T")[0],
      F_LedgerMaster: -1,
    },
    FillArray: [],
    FillArray2: [],
    FillArray3: [],
    FillArray4: [],
    FillArray6: [],
    FillArray7: [],
    FillArray8: [],
    
    isProgress: true,
  });

  const [rows, setRows] = useState([]);
  const [IsOver, setIsOver] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [TotalQuantity, setTotalQuantity] = useState(0);
  const [GrossAmount, setGrossAmount] = useState(0);
  const [totalSGST, setTotalSGST] = useState(0);
  const [totalCGST, setTotalCGST] = useState(0);
  const [TaxAmount, setTotalTax] = useState(0);
  const [NetAmount, setNetAmount] = useState(0);

  const dispatch = useDispatch()
  const location = useLocation()

  const API_URL = `${API_WEB_URLS.MASTER}/0/token/CustomerLedgerBySale`
  const API_URL2 = `${API_WEB_URLS.MASTER}/0/token/GetVoucherNo`
  const API_URL3 = `${API_WEB_URLS.MASTER}/0/token/Sales`
  const API_URLL = `${API_WEB_URLS.MASTER}/0/token/SaleL`
  const API_URL4 = `${API_WEB_URLS.MASTER}/0/token/CheckPlan`
  const API_URL5 = `${API_WEB_URLS.MASTER}/0/token/ItemType`
  const API_URL6 = `${API_WEB_URLS.MASTER}/0/token/Weight`
  const API_URL_Item = "GetRemainingStocks/0/token"
  const API_URL_SAVEH = "InvoiceH/0/token"
  const API_URL_SAVEL = "InvoiceL/0/token"
  const API_URL_SAVETax = "InvoiceTax/0/token"
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/SaleH/TBL.Id`



  useEffect(() => {
    const fetchData = async () => {
      // First, fill initial data
    
      await Fn_FillListData(dispatch, setState, "FillArray3", `${API_URL3}/Id/0`);
      await Fn_FillListData(dispatch, setState, "FillArray7", `${API_URL5}/Id/0`);
      await Fn_FillListData(dispatch, setState, "FillArray8", `${API_URL6}/Id/0`);
      const response = await Fn_FillListData(dispatch, setState, "FillArray4", `${API_URL2}/Id/0`);
      if(response[0]){
        setState((prevState) => ({
          ...prevState,
          formData: {
            ...prevState.formData,
            ['VoucherNo']: response[0].VoucherNo,
          },
        }));
      }
    
      const Id = (location.state && location.state.Id) || 0;
      if (Id > 0) {
        setState(prevState => ({ ...prevState, id: Id }));
        
        // Fetch display data asynchronously
       const response =  await Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
        if(response.dataList[0].F_SalesMaster){
         
          
        }

        const res = await Fn_FillListData(dispatch, setState, "FillArray6", `${API_URLL}/TBL.F_SaleInvoiceH/${Id}`);
        console.log(res,'response')
        for(let i =0;i<res.length;i++){
          let vformData = new FormData();
          vformData.append("F_BrandMaster", res[i].F_BrandMaster);
          vformData.append("F_WeightCategory", res[i].F_WeightCategory);
          vformData.append("F_SalesMaster", response.dataList[0].F_SalesMaster );
          Fn_FillListData(dispatch, setState, "FillArray", `${API_URL}/Id/${response.dataList[0].F_SalesMaster}`);
          await Fn_GetReport(dispatch, setState, "ItemArray", API_URL_Item,  { arguList: { id: 0, formData: vformData }}, true,i,state.FillArray2,'FillArray2');
        }
        setRows(res)
      }
    };
  
    fetchData();
  }, [dispatch, location.state]);
  
  useEffect(() => {
    updateTotals(rows)
  }, [rows]);
  
  
  const updateTotals = (updatedRows) => {
    
    const totalQty = updatedRows.reduce((acc, row) => acc + row.Quantity, 0);
    const grossAmt = updatedRows.reduce((acc, row) => acc + row.Total, 0);
    console.log(grossAmt,rows,'gross amount');
    let totalSGST = 0;
    let totalCGST = 0;
  
    updatedRows.forEach((row,index) => {
      const item = state.FillArray2[index] && state.FillArray2[index].find((item,i) => item.Id == row.F_ItemMaster);
  
      if (item) {
        const IGST = parseFloat(item.IGST) || 0;
        const SGST_CGST = IGST / 2;
        totalSGST += (row.Total * SGST_CGST) / 100;
        totalCGST += (row.Total * SGST_CGST) / 100;
      }
    });
  
    const TaxAmount = totalSGST + totalCGST;
    const netAmt = grossAmt + TaxAmount;
  
    setTotalQuantity(totalQty);
    setGrossAmount(grossAmt);
    setTotalSGST(totalSGST);
    setTotalCGST(totalCGST);
    setTotalTax(TaxAmount);
    setNetAmount(netAmt);
  };

  const editRow = async (index, field, value) => {
    let updatedRows = [...rows]; // Create a copy of the current rows
    let discount = 0;
    updatedRows[index][field] = value;
  
    if (field == "F_ItemMaster" ) {
      const selectedProduct = state.FillArray2[index].find((item, i) => item.Id == value);
      console.log(updatedRows, 'here', selectedProduct);
      if (selectedProduct) {
        updatedRows[index].Rate = selectedProduct.price;
      }
    }
   
    if(updatedRows[index].F_BrandMaster >0 && updatedRows[index].F_WeightCategory > 0 && state.formData.F_SalesMaster ){
      let vformData = new FormData();
      vformData.append("F_BrandMaster", updatedRows[index].F_BrandMaster);
      vformData.append("F_WeightCategory", updatedRows[index].F_WeightCategory);
      vformData.append("F_SalesMaster", state.formData.F_SalesMaster );
      
      Fn_GetReport(dispatch, setState, "ItemArray", API_URL_Item,  { arguList: { id: 0, formData: vformData }}, true,index,state.FillArray2,'FillArray2');
    }
    // Reset discount when quantity changes
    if (field === "Quantity") {
      

      updatedRows[index].Discount = 0;  // Reset discount to 0 whenever quantity changes
      if(updatedRows[index].F_ItemMaster){
        const selectedProduct = state.FillArray2[index].find((item, i) => item.Id == updatedRows[index].F_ItemMaster);
        if(selectedProduct.Quantity<value){
          console.log(selectedProduct)
          alert(`Quantity not enough : Available is ${selectedProduct.Quantity}`)
          updatedRows[index].Quantity = 0;
          return;
        }
      }
     
    }
    
    if (state.FillArray2.length > 0 && field == 'Quantity' && updatedRows[index].F_ItemMaster > 0) {
      try {
        const response = await Fn_FillListData(dispatch, setState, "FillArray5", `${API_URL4}/${updatedRows[index].F_ItemMaster}/${value}`);
        if (response && response.length > 0) {
          const { IsFlat, Amount } = response[0];
  
          // Update the Total based on Quantity and Rate first
          let totalAmount = updatedRows[index].Rate * updatedRows[index].Quantity;
  
          // Calculate Discount based on IsFlat or Percentage
        
          if (IsFlat) {
            // Flat discount: subtract Amount directly from the calculated total
            discount = Number(Amount);
          } else {
            // Percentage discount: calculate percentage reduction
            discount = totalAmount * (Number(Amount) / 100);
          }
  
          // Apply the discount to the total amount
          updatedRows[index].Discount = discount;
  
          // Recalculate Total after applying discount
         
  
          console.log("Discount applied: ", discount);
          console.log("New Total: ", updatedRows[index].Total);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } 
      // If no discount is applied, simply calculate Total as Rate * Quantity
      updatedRows[index].Total = updatedRows[index].Rate * updatedRows[index].Quantity - discount;
   
  
    // Finally, update the state with the modified rows
    setRows(updatedRows);
    updateTotals(updatedRows)
  };
  const addRow = () => {
    setRows((prevRows) => [
      ...prevRows,
      {
        F_BrandMaster: "",
        F_WeightCategory: "",
        F_ItemMaster: "",
        Rate: 0,
        Quantity: 1,
        Total: 0,
        Discount: 0,
      },
    ]);
  };
  const deleteRow = (index) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows.splice(index, 1);
      return updatedRows;
    });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(name,value)
    setState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));

    if(name=='F_SalesMaster'){
       Fn_FillListData(dispatch, setState, "FillArray", `${API_URL}/Id/${value}`);
    }
  };

  const handleSubmit = async () => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    let  F_SaleInvoiceH = 0
    const formData = new FormData();
    formData.append("VoucherNo", state.formData.VoucherNo);
    formData.append("VoucherDate", state.formData.VoucherDate);
    formData.append("F_SalesMaster", state.formData.F_SalesMaster);
    formData.append("F_LedgerMaster", state.formData.F_LedgerMaster);
    formData.append("TotalQuantity", TotalQuantity);
    formData.append("GrossAmount", GrossAmount);
    formData.append("GrossAmount", GrossAmount);
    formData.append("TaxAmount", TaxAmount);
    formData.append("NetAmount", NetAmount);
    formData.append("F_UserMaster", obj.uid);
  
    try {
      const response = await Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVEH,
        true,
        "memberid"
      );
  
      if(response && response.id)
      {
        F_SaleInvoiceH = response.id
        console.log("F_SaleInvoiceH",F_SaleInvoiceH)

        const formData1 = new FormData();
        formData1.append("F_SaleInvoiceH", F_SaleInvoiceH);
        formData1.append("Data",JSON.stringify(rows) );
        
        await Fn_AddEditData(
          dispatch,
          setState,
          { arguList: { id: 0, formData : formData1 } },
          API_URL_SAVEL,
          true,
          "memberid"
        );

      
      }
   
    } catch (error) {
      console.error("Error submitting data:", error);
    }

    
  };
  


  return (
    <React.Fragment>
      <div className="page-content">
        <h2>Sales Invoice</h2>
        <Row className="mb-3">
          <Col lg="2" className="m-2">
            <label htmlFor="VoucherNo">Voucher No</label>
          </Col>
          <Col lg="3">
            <Input
              type="text"
              name="VoucherNo"
              value={state.formData.VoucherNo}
              onChange={handleInputChange}
            />
          </Col>
          <Col lg="2" className="m-2">
            <label htmlFor="VoucherDate">Voucher Date</label>
          </Col>
          <Col lg="3">
            <Input
              type="date"
              name="VoucherDate"
              value={state.formData.VoucherDate }
              onChange={handleInputChange}
            />
          </Col>
        </Row>

        <Row className="mb-3">
        <Col lg="2" className="m-2">
            <label htmlFor="F_SalesMaster">Against Sales Person</label>
          </Col>
          <Col lg="3">
            <Input
              type="select"
              name="F_SalesMaster"
              value={state.formData.F_SalesMaster}
              onChange={handleInputChange}
            >
              <option value={-1}>Select Sales Person</option>
              {state.FillArray3.map((type) => (
                <option key={type.Id} value={type.Id}>
                  {type.Name}
                </option>
              ))}
            </Input>
          </Col>
          <Col lg="2" className="m-2">
            <label htmlFor="F_LedgerMaster">Ledger</label>
          </Col>
          <Col lg="3">
            <Input
              type="select"
              name="F_LedgerMaster"
              value={state.formData.F_LedgerMaster}
              onChange={handleInputChange}
            >
              <option value={-1}>Select Ledger</option>
              {state.FillArray.map((type) => (
                <option key={type.Id} value={type.Id}>
                  {type.Name}
                </option>
              ))}
            </Input>
          </Col>
        
        </Row>

        <div className="invoice-section">
          <h4>Items</h4>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Brand</th>
                <th>Weight Category</th>
                <th>Item</th>
                <th>Quantity</th>
                <th>Rate</th>
                <th>Total</th>
                <th>Discount</th>
                <th>SGST</th>
                <th>CGST</th>
                <th>IGST</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>

                <InvoiceItemRow
                  WeightCategory={state.FillArray8}
                  ProductArray={state.FillArray2}
                  BrandArr={state.FillArray7}
                  rows = {rows}
                  onDelete={deleteRow}
                  onEdit ={editRow}
                />

            </tbody>
          </table>
          <button className="btn btn-primary" onClick={addRow}>
            Add Item
          </button>
        </div>

        <Row>
          <Col lg="6">
            <Row className="mb-3">
              <Col sm="2">
                <label>Total Quantity</label>
              </Col>
              <Col sm="3">
                <Input
                  name="TotalQuantity"
                  value={TotalQuantity || 0}
                  type="text"
                  className="form-control"
                  disabled
                />
              </Col>
              <Col sm="2">
                <label>Gross Amount</label>
              </Col>
              <Col sm="3">
                <Input
                  name="GrossAmount"
                  value={GrossAmount || 0}
                  type="text"
                  className="form-control"
                  disabled
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm="2">
                <label>SGST</label>
              </Col>
              <Col sm="3">
                <Input
                  name="SGST"
                  value={totalSGST || 0}
                  type="text"
                  className="form-control"
                  disabled
                />
              </Col>
              <Col sm="2">
                <label>CGST</label>
              </Col>
              <Col sm="3">
                <Input
                  name="CGST"
                  value={totalCGST || 0}
                  type="text"
                  className="form-control"
                  disabled
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm="2">
                <label>Total Tax</label>
              </Col>
              <Col sm="3">
                <Input
                  name="TotalTax"
                  value={TaxAmount || 0}
                  type="text"
                  className="form-control"
                  disabled
                />
              </Col>
              <Col sm="2">
                <label>Net Amount</label>
              </Col>
              <Col sm="3">
                <Input
                  name="NetAmount"
                  value={NetAmount || 0}
                  type="text"
                  className="form-control"
                  disabled
                />
              </Col>
            </Row>
          </Col>

          {/* <Col lg="6">
            <h4>Total Amount</h4>
            <p>${totalAmount.toFixed(2)}</p>
          </Col> */}
        </Row>

        <Button color="primary" onClick={handleSubmit}>
          Submit Invoice
        </Button>
      </div>
    </React.Fragment>
  );
}

export default SaleInvoice
